import type { ComponentPropsWithoutRef } from "react";

/** A page panel: rounded 20px, thin border, no shadow (section 11.0). */
export function Panel({ className = "", ...props }: ComponentPropsWithoutRef<"section">) {
  return (
    <section
      className={`rounded-panel border border-line bg-panel p-5 ${className}`.trim()}
      {...props}
    />
  );
}
